import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ element }) {
  const user = localStorage.getItem("user");
  
  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user is logged in, render the protected component
  return element;
}
